import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'DoorIcon',
  functional: true,
  render: function render(h, ctx) {
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 64 64",
        fill: "currentColor",
        stroke: "currentColor",
        "stroke-width": "1",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      },
      "class": "feather"
    }, ctx.data]), [
        h("path", {
          attrs: {
            d: "m21 23h22a1 1 0 0 0 1-1v-12a1 1 0 0 0 -1-1h-22a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1zm1-12h20v10h-20z"
          }
        }),
      h("path", {
        attrs: {
          d: "m21 37a3 3 0 1 0 -3-3 3 3 0 0 0 3 3zm0-4a1 1 0 1 1 -1 1 1 1 0 0 1 1-1z"
        }
      }),
      h("path", {
        attrs: {
          d: "m58 60v-5a1 1 0 0 0 -1-1h-4v-52a1 1 0 0 0 -1-1h-40a1 1 0 0 0 -1 1v52h-4a1 1 0 0 0 -1 1v5h-4v2h60v-2zm-45-57h38v51h-1v-49a1 1 0 0 0 -1-1h-34a1 1 0 0 0 -1 1v49h-1zm35 3v48h-32v-48zm8 54h-48v-4h48z"
        }
      })
    ]);
  }
};